// extracted by mini-css-extract-plugin
export var progressBar = "_ji-0";
export var progressBarInner = "_ji-1";